/*
 * BuildDocs пользовательский интерфейс version 0.1.0
 *
 * Copyright © 2022 ООО АДАПТ info@acfs.spb.ru
 * You may use, distribute and modify this code under the
 * terms of the ООО АДАПТ license
 */

import {
  formatPhoneNumber,
  getShortName,
  Organization,
  User,
  useRouter,
  routes,
} from '@builddocs/data-management'
import { GridPairs } from '@builddocs/mui'
import { Card, CardContent, CardHeader, Tooltip } from '@mui/material'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import { format } from 'date-fns'
import { ru } from 'date-fns/locale'

interface IInfoBlock {
  user: User
  loading: boolean
  organization?: Organization
}

interface IAccountMenu {
  onClickEdit: () => void
}

type Props = IInfoBlock & IAccountMenu

export function GeneralUserInfo({ user, onClickEdit }: Props): JSX.Element {
  const { dateOfBirth, phone, email, nostroyId } = user

  const { navigate } = useRouter()

  return (
    <Card sx={{ height: '240px' }}>
      <CardHeader
        action={
          <Button size="small" onClick={onClickEdit}>
            Редактировать
          </Button>
        }
        subheader={user.employment?.position?.description ?? 'Не работаю'}
        title={getShortName(user)}
      />
      <CardContent>
        <GridPairs
          content={[
            dateOfBirth
              ? [
                  'День рождения',
                  format(new Date(dateOfBirth), 'd MMMM', { locale: ru }),
                ]
              : null,
            [
              'Эл. почта',
              <Tooltip key="email" placement="right" title="Написать">
                <Link href={`mailto:${email}`}>{email}</Link>
              </Tooltip>,
            ],
            [
              'Моб. телефон',
              <Tooltip key="phone" placement="right" title="Позвонить">
                <Link href={`tel:${phone}`}>{formatPhoneNumber(phone)}</Link>
              </Tooltip>,
            ],
            [
              'НРС',
              nostroyId ?? (
                <Link
                  color="text.secondary"
                  onClick={() => navigate(routes.account.edit())}
                >
                  Настроить
                </Link>
              ),
            ],
          ]}
        />
      </CardContent>
    </Card>
  )
}
